/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../sub2/data';
import '../common/time';
import '../fees/models';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "rewards": {
        "nested": {
          "RewardName": {
            "values": {
              "UNKNOWN": 0,
              "AU_INVOICE_FREE_PROCESSING": 1,
              "FREE_PROCESSING": 2,
              "PDX_CONTACTLESS_FREE_PROCESSING": 3,
              "APPOINTMENTS_HALF_OFF_MONTH": 4,
              "NON_APPLE_PAY_NFC_FREE_PROCESSING": 5,
              "R12_FREE_PROCESSING": 6,
              "APPLE_PAY_NFC_FREE_PROCESSING": 7,
              "INVOICE_FREE_PROCESSING": 8,
              "AMEX_FREE_PROCESSING": 9,
              "APPOINTMENTS_FREE_MONTH": 10,
              "PRICING_ADJUSTMENT": 11,
              "PROMO_CODE": 12,
              "CA_CREDIT_CARDS_FREE_PROCESSING": 13,
              "SELECTABLE": 14,
              "FREE_R4X_READER_QUOTA": 15,
              "T2_FREE_PROCESSING": 16,
              "X2_FREE_PROCESSING": 17,
              "FREE_RATE": 18,
              "T2_FREE_RATE": 19,
              "SQUARE_INSTALLMENTS_FREE_PROCESSING": 20,
              "TRANSACTIONAL_SELECTABLE": 21,
              "ONE_TRANSACTIONAL_SELECTABLE": 22,
              "FIVE_TRANSACTIONAL_SELECTABLE": 23,
              "APPOINTMENTS_SAAS_DISCOUNT_PLUS": 24,
              "REAL_MONEY": 25,
              "CREDIT_CARD_REWARDS_FREE_PROCESSING": 26,
              "APPOINTMENTS_SAAS_DISCOUNT_PREMIUM": 27,
              "RESTAURANTS_PLUS_SAAS_DISCOUNT": 28,
              "RETAIL_PLUS_SAAS_DISCOUNT": 29,
              "KDS_SAAS_DISCOUNT": 30,
              "LOYALTY_SAAS_DISCOUNT": 31,
              "MARKETING_SAAS_DISCOUNT": 32,
              "REFEREE_SELECTABLE": 33,
              "HIGH_VALUE_REFERRAL_BONUS": 34,
              "PAYROLL_FOR_EMPLOYEES_SAAS_DISCOUNT": 35,
              "PAYROLL_FOR_EMPLOYEES_WITH_FREE_TRIALS_SAAS_DISCOUNT": 50,
              "SQUARE_DEBIT_CARD_INCENTIVE_FREE_PROCESSING": 36,
              "SUBSCRIPTION_PRODUCT_USAGE_DISCOUNT": 37,
              "HW_SW_BUNDLE_SAAS_DISCOUNT": 38,
              "LOYALTY_TWENTY_PERCENT_OFF_LIFETIME": 39,
              "ECOM_SO_PLUS_TWENTY_PERCENT_OFF_LIFETIME": 40,
              "ECOM_SO_PREMIUM_TWENTY_PERCENT_OFF_LIFETIME": 41,
              "MARKETING_TWENTY_PERCENT_OFF_LIFETIME": 42,
              "ECOM_SO_PROFESSIONAL_DISCOUNT": 43,
              "ECOM_SO_PLUS_DISCOUNT": 44,
              "ECOM_SO_PREMIUM_DISCOUNT": 45,
              "MULTI_REWARD": 46,
              "FREE_INSTANT_TRANSFERS": 47,
              "INVOICES_PLUS_SAAS_DISCOUNT": 48,
              "PROMOTIONAL_PROCESSING_RATE": 49,
              "SOLIDSHOP_PROMOTION": 51,
              "CASH_APP_PAY_FREE_PROCESSING": 52,
              "GIFT_CARD": 53,
              "SQUARE_ONE_FREE_SAAS_DISCOUNT": 54,
              "SQUARE_ONE_PLUS_SAAS_DISCOUNT": 55,
              "SQUARE_ONE_PREMIUM_SAAS_DISCOUNT": 56,
              "PRICING_PLAN_SERVICE_INTEGRATION": 57
            }
          },
          "Reward": {
            "fields": {
              "name": {
                "type": "squareup.rewards.RewardName",
                "id": 1,
                "rule": "optional"
              },
              "priority": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "grantAmount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "expiresInDays": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "active": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "type": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "Campaign": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "reward": {
                "type": "squareup.rewards.Reward",
                "id": 2,
                "rule": "optional"
              },
              "creator": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "grantAmount": {
                "type": "squareup.rewards.AmountDetail",
                "id": 4,
                "rule": "optional"
              },
              "expiresInDays": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "grantPercentage": {
                "type": "squareup.rewards.PercentDetail",
                "id": 7,
                "rule": "optional"
              },
              "grantDetails": {
                "type": "squareup.rewards.Campaign.GrantDetail",
                "id": 8,
                "rule": "repeated"
              },
              "grantValue": {
                "type": "squareup.common.Money",
                "id": 9,
                "rule": "optional"
              }
            },
            "nested": {
              "GrantDetail": {
                "fields": {
                  "usageUnitType": {
                    "type": "squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percentDiscount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "numUses": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maxUnitsPerUse": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "Balance": {
            "fields": {
              "id": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 4,
                "rule": "optional"
              },
              "amount": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "amountDetail": {
                "type": "squareup.rewards.AmountDetail",
                "id": 6,
                "rule": "optional"
              },
              "expiresAt": {
                "type": "squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              },
              "campaign": {
                "type": "squareup.rewards.Campaign",
                "id": 9,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "grantAmount": {
                "type": "int32",
                "id": 11,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "status": {
                "type": "squareup.rewards.Balance.Status",
                "id": 13,
                "rule": "optional"
              },
              "claimedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 14,
                "rule": "optional"
              },
              "mobileBalanceHeading": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "mobileBalanceText": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2
              },
              "merchantToken": {
                "type": "string",
                "id": 3
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "ACTIVE": 1,
                  "EXPIRED": 2,
                  "EXHAUSTED": 3
                }
              },
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "AmountDetail": {
            "fields": {
              "type": {
                "type": "squareup.rewards.AmountDetail.Type",
                "id": 1,
                "rule": "optional"
              },
              "moneyAmount": {
                "type": "squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "months": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "quota": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "usageUnitType": {
                "type": "squareup.sub2.data.UsageUnitType",
                "id": 5,
                "rule": "optional"
              },
              "usageUnitQuantity": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "progressAmount": {
                "type": "int32",
                "id": 7,
                "rule": "optional"
              },
              "promotionalProcessingRates": {
                "type": "squareup.rewards.PromotionalProcessingRate",
                "id": 8,
                "rule": "repeated"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN": 0,
                  "FREE_PROCESSING": 1,
                  "SUBSCRIPTION_PRODUCT_DISCOUNT": 2,
                  "PRICING_ADJUSTMENT": 3,
                  "PROMO_CODE": 4,
                  "QUOTA_AMOUNT": 5,
                  "REAL_MONEY": 6,
                  "SUBSCRIPTION_PRODUCT_USAGE_DISCOUNT": 7,
                  "CAMPAIGN_PROGRESS": 8,
                  "PROMOTIONAL_PROCESSING_RATE": 9
                }
              }
            }
          },
          "PromotionalProcessingRate": {
            "fields": {
              "feePlanProductBase": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "feePlanProductTier": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "entryMethod": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "oldRate": {
                "type": "squareup.fees.SimpleRate",
                "id": 4,
                "rule": "optional"
              },
              "newRate": {
                "type": "squareup.fees.SimpleRate",
                "id": 5,
                "rule": "optional"
              },
              "hardware": {
                "type": "string",
                "id": 6,
                "rule": "repeated"
              }
            }
          },
          "PercentDetail": {
            "fields": {
              "type": {
                "type": "squareup.rewards.PercentDetail.Type",
                "id": 1,
                "rule": "optional"
              },
              "percent": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN": 0,
                  "SUBSCRIPTION_PRODUCT_DISCOUNT": 1
                }
              }
            }
          },
          "FreeProcessingAdjustment": {
            "fields": {
              "id": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "amount": {
                "type": "squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              },
              "ledgerToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "entryType": {
                "type": "squareup.rewards.FreeProcessingAdjustment.EntryType",
                "id": 8,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "refundUuid": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "relatedEntryType": {
                "type": "squareup.rewards.RelatedEntryType",
                "id": 11,
                "rule": "optional"
              }
            },
            "nested": {
              "EntryType": {
                "values": {
                  "UNKNOWN": 0,
                  "PAYMENT": 1,
                  "REFUND": 2,
                  "UNDO": 3,
                  "FEE": 4
                }
              }
            }
          },
          "RelatedEntryType": {
            "values": {
              "UNKNOWN_RELATED_ENTRY_TYPE": 0,
              "PAYMENT": 1,
              "REFUND": 2,
              "UNDO": 3
            }
          },
          "BalanceChange": {
            "fields": {
              "id": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "amount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "source": {
                "type": "squareup.rewards.BalanceChange.Source",
                "id": 3,
                "rule": "optional"
              },
              "reason": {
                "type": "squareup.rewards.BalanceChange.Reason",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "reasonDetail": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              }
            },
            "nested": {
              "Source": {
                "values": {
                  "UNKNOWN_SOURCE": 0,
                  "INTERNAL": 1,
                  "INVOICES": 2,
                  "ONBOARD": 3,
                  "REGULATOR": 4,
                  "SHOP": 5,
                  "SCRIPT": 6,
                  "BILLING": 7,
                  "INSTALLMENTS": 8,
                  "WEBHOOK": 9
                }
              },
              "Reason": {
                "values": {
                  "UNKNOWN_REASON": 0,
                  "GRANT": 1,
                  "PAYMENT": 2,
                  "REFUND": 3,
                  "UNDO": 4,
                  "MANUAL_GRANT": 5,
                  "MANUAL_DECREMENT": 6,
                  "DIRECT_MAIL": 7,
                  "EXPIRED_BALANCE": 8,
                  "SETTLEMENT": 9,
                  "READER_ORDER": 10,
                  "READER_ORDER_CANCEL": 11,
                  "FEE": 12,
                  "NEW_TRANSFER": 13,
                  "FAILED_TRANSFER": 14
                }
              }
            }
          },
          "BalanceDetail": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              },
              "grantAmount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "grantedBy": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "approvedBy": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "productTag": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "campaignDetails": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "sellerType": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              }
            }
          },
          "FinanceProduct": {
            "fields": {
              "tag": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "FinanceCampaignDetail": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RewardCodeReceiver": {
            "fields": {
              "idempotenceToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "receiverDisplayName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "receiverStatus": {
                "type": "squareup.rewards.RewardCodeReceiver.ReceiverStatus",
                "id": 3,
                "rule": "optional"
              },
              "receiverStatusDisplayText": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "ReceiverStatus": {
                "values": {
                  "UNKNOWN": 0,
                  "REWARD_CODE_SHARED": 1,
                  "REWARD_CODE_USED": 2,
                  "REWARD_CODE_USE_ACTIVATED": 3,
                  "RECEIVER_REWARD_GRANTED": 4,
                  "TRANSACTION_CAPTURED": 5,
                  "SENDER_REWARD_GRANTED": 6
                }
              }
            }
          },
          "SelectableOffer": {
            "fields": {
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 1,
                "rule": "optional"
              },
              "rewardHeading": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "rewardText": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "mobileRewardHeading": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "mobileRewardText": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "rewardNameString": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "RedeemableReward": {
            "fields": {
              "rewardCodeUseId": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              },
              "rewardHeading": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "rewardText": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "mobileRewardHeading": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "mobileRewardText": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "rewardNameString": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "Error": {
            "fields": {
              "field": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "StatusResponse": {
            "fields": {
              "success": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": "squareup.rewards.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "PromotionalOffer": {
            "fields": {
              "offerName": {
                "type": "squareup.rewards.PromotionalOffer.OfferName",
                "id": 1,
                "rule": "optional"
              },
              "offerHeading": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "offerText": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "mobileOfferHeading": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "mobileOfferText": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "offerNameString": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "currentAmount": {
                "type": "squareup.rewards.AmountDetail",
                "id": 7,
                "rule": "optional"
              }
            },
            "nested": {
              "OfferName": {
                "values": {
                  "HIGH_VALUE_REFERRAL_BONUS_REFEREE": 1,
                  "HIGH_VALUE_REFERRAL_BONUS_REFERRER": 2,
                  "EARLY_SELLER_ENGAGEMENT": 3
                }
              }
            }
          },
          "RedemptionCodeInternal": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "amount": {
                "type": "squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "claimedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE RewardName @ squareup/rewards/common.proto at 12:1
 */
export const RewardName = $root.lookupEnum('squareup.rewards.RewardName').values;
/**
 * SOURCE Reward @ squareup/rewards/common.proto at 81:1
 */
export const Reward = $root.lookupType('squareup.rewards.Reward');
fixType(Reward);
Builder.createAndAttachToType(Reward);
/**
 * SOURCE Campaign @ squareup/rewards/common.proto at 91:1
 */
export const Campaign = $root.lookupType('squareup.rewards.Campaign');
fixType(Campaign);
Builder.createAndAttachToType(Campaign);
/**
 * SOURCE GrantDetail @ squareup/rewards/common.proto at 92:3
 */
Campaign.GrantDetail = $root.lookupType('squareup.rewards.Campaign.GrantDetail');
fixType(Campaign.GrantDetail);
Builder.createAndAttachToType(Campaign.GrantDetail);
/**
 * SOURCE Balance @ squareup/rewards/common.proto at 110:1
 */
export const Balance = $root.lookupType('squareup.rewards.Balance');
fixType(Balance);
Builder.createAndAttachToType(Balance);
/**
 * SOURCE Status @ squareup/rewards/common.proto at 111:3
 */
Balance.Status = $root.lookupEnum('squareup.rewards.Balance.Status').values;
/**
 * SOURCE AmountDetail @ squareup/rewards/common.proto at 142:1
 */
export const AmountDetail = $root.lookupType('squareup.rewards.AmountDetail');
fixType(AmountDetail);
Builder.createAndAttachToType(AmountDetail);
/**
 * SOURCE Type @ squareup/rewards/common.proto at 143:3
 */
AmountDetail.Type = $root.lookupEnum('squareup.rewards.AmountDetail.Type').values;
/**
 * SOURCE PromotionalProcessingRate @ squareup/rewards/common.proto at 166:1
 */
export const PromotionalProcessingRate = $root.lookupType('squareup.rewards.PromotionalProcessingRate');
fixType(PromotionalProcessingRate, {
  feePlanProductBase: { required: true },
  entryMethod: { required: true },
  oldRate: { required: true },
  newRate: { required: true },
});
Builder.createAndAttachToType(PromotionalProcessingRate);
/**
 * SOURCE PercentDetail @ squareup/rewards/common.proto at 182:1
 */
export const PercentDetail = $root.lookupType('squareup.rewards.PercentDetail');
fixType(PercentDetail);
Builder.createAndAttachToType(PercentDetail);
/**
 * SOURCE Type @ squareup/rewards/common.proto at 183:3
 */
PercentDetail.Type = $root.lookupEnum('squareup.rewards.PercentDetail.Type').values;
/**
 * SOURCE FreeProcessingAdjustment @ squareup/rewards/common.proto at 192:1
 */
export const FreeProcessingAdjustment = $root.lookupType('squareup.rewards.FreeProcessingAdjustment');
fixType(FreeProcessingAdjustment);
Builder.createAndAttachToType(FreeProcessingAdjustment);
/**
 * SOURCE EntryType @ squareup/rewards/common.proto at 193:3
 */
FreeProcessingAdjustment.EntryType = $root.lookupEnum('squareup.rewards.FreeProcessingAdjustment.EntryType').values;
/**
 * SOURCE RelatedEntryType @ squareup/rewards/common.proto at 214:1
 */
export const RelatedEntryType = $root.lookupEnum('squareup.rewards.RelatedEntryType').values;
/**
 * SOURCE BalanceChange @ squareup/rewards/common.proto at 221:1
 */
export const BalanceChange = $root.lookupType('squareup.rewards.BalanceChange');
fixType(BalanceChange);
Builder.createAndAttachToType(BalanceChange);
/**
 * SOURCE Source @ squareup/rewards/common.proto at 222:3
 */
BalanceChange.Source = $root.lookupEnum('squareup.rewards.BalanceChange.Source').values;
/**
 * SOURCE Reason @ squareup/rewards/common.proto at 235:3
 */
BalanceChange.Reason = $root.lookupEnum('squareup.rewards.BalanceChange.Reason').values;
/**
 * SOURCE BalanceDetail @ squareup/rewards/common.proto at 265:1
 */
export const BalanceDetail = $root.lookupType('squareup.rewards.BalanceDetail');
fixType(BalanceDetail);
Builder.createAndAttachToType(BalanceDetail);
/**
 * SOURCE FinanceProduct @ squareup/rewards/common.proto at 277:1
 */
export const FinanceProduct = $root.lookupType('squareup.rewards.FinanceProduct');
fixType(FinanceProduct);
Builder.createAndAttachToType(FinanceProduct);
/**
 * SOURCE FinanceCampaignDetail @ squareup/rewards/common.proto at 282:1
 */
export const FinanceCampaignDetail = $root.lookupType('squareup.rewards.FinanceCampaignDetail');
fixType(FinanceCampaignDetail);
Builder.createAndAttachToType(FinanceCampaignDetail);
/**
 * SOURCE RewardCodeReceiver @ squareup/rewards/common.proto at 286:1
 */
export const RewardCodeReceiver = $root.lookupType('squareup.rewards.RewardCodeReceiver');
fixType(RewardCodeReceiver);
Builder.createAndAttachToType(RewardCodeReceiver);
/**
 * SOURCE ReceiverStatus @ squareup/rewards/common.proto at 287:3
 */
RewardCodeReceiver.ReceiverStatus = $root.lookupEnum('squareup.rewards.RewardCodeReceiver.ReceiverStatus').values;
/**
 * SOURCE SelectableOffer @ squareup/rewards/common.proto at 303:1
 */
export const SelectableOffer = $root.lookupType('squareup.rewards.SelectableOffer');
fixType(SelectableOffer);
Builder.createAndAttachToType(SelectableOffer);
/**
 * SOURCE RedeemableReward @ squareup/rewards/common.proto at 312:1
 */
export const RedeemableReward = $root.lookupType('squareup.rewards.RedeemableReward');
fixType(RedeemableReward);
Builder.createAndAttachToType(RedeemableReward);
/**
 * SOURCE Error @ squareup/rewards/common.proto at 341:1
 */
export const Error = $root.lookupType('squareup.rewards.Error');
fixType(Error);
Builder.createAndAttachToType(Error);
/**
 * SOURCE StatusResponse @ squareup/rewards/common.proto at 346:1
 */
export const StatusResponse = $root.lookupType('squareup.rewards.StatusResponse');
fixType(StatusResponse);
Builder.createAndAttachToType(StatusResponse);
/**
 * SOURCE PromotionalOffer @ squareup/rewards/common.proto at 351:1
 */
export const PromotionalOffer = $root.lookupType('squareup.rewards.PromotionalOffer');
fixType(PromotionalOffer);
Builder.createAndAttachToType(PromotionalOffer);
/**
 * SOURCE OfferName @ squareup/rewards/common.proto at 353:3
 */
PromotionalOffer.OfferName = $root.lookupEnum('squareup.rewards.PromotionalOffer.OfferName').values;
/**
 * SOURCE RedemptionCodeInternal @ squareup/rewards/common.proto at 367:1
 */
export const RedemptionCodeInternal = $root.lookupType('squareup.rewards.RedemptionCodeInternal');
fixType(RedemptionCodeInternal);
Builder.createAndAttachToType(RedemptionCodeInternal);
